import React from 'react'
import { pxToRem, COLOR } from 'theme'
import { Dialog } from 'components/Dialog'
import Button from 'components/Button'
import Card from 'components/Card'
import { Text } from 'components/Typography'
import { Box } from 'components/Layout'

const WARNING_MESSAGE =
  'Unable to finish the testing session. Please check if patients were invited to the session and tested patient‘s information was filled out correctly (First name, Last name, Address, Birthdate, Phone number, Gender, Ethnicity, Race).'

interface Props {
  isOpen?: boolean
  onDismiss: () => void
  totalTested: number
  totalParticipants: number
  onFinish: () => void
  isFinishTestSessionLoading?: boolean
  isFinishTestSessionAllowed: boolean
  showDeleteButton?: boolean
  onDelete: () => void
}

export const FinishTestSessionDialog: React.VFC<Props> = ({
  isOpen,
  onDismiss,
  totalTested,
  totalParticipants,
  onFinish,
  isFinishTestSessionLoading,
  isFinishTestSessionAllowed,
  showDeleteButton,
  onDelete,
}) => (
  <Dialog isOpen={isOpen} onDismiss={onDismiss} maxWidth={pxToRem(512)}>
    <Card>
      <Card.Title onDismiss={onDismiss}>Finish testing session</Card.Title>
      <Card.Content display="grid" gridGap="0.5rem">
        {isFinishTestSessionAllowed ? (
          <>
            <ul>
              <li>Total participants: {totalParticipants}</li>
              <li>Total tested: {totalTested}</li>
            </ul>
            <Box display="flex" justifyContent="space-between">
              <Button
                isFetching={isFinishTestSessionLoading}
                colorVariant="primary"
                onClick={onFinish}
              >
                Confirm finish
              </Button>
              {showDeleteButton && (
                <Button
                  isFetching={isFinishTestSessionLoading}
                  colorVariant="danger"
                  onClick={onDelete}
                >
                  Delete TestSession
                </Button>
              )}
            </Box>
          </>
        ) : (
          <>
            <Text color={COLOR.brand}>{WARNING_MESSAGE}</Text>
            <Button mt="1rem" onClick={onDismiss}>
              I agree
            </Button>
          </>
        )}
      </Card.Content>
    </Card>
  </Dialog>
)
